/* eslint-disable react/display-name */
import React, { useState, forwardRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Module from './Module';
import Component from './Component/Component';
import Page from './Page/Page';
import { find, isEmpty } from 'lodash'

const ObjectListItem = props => {
  const {
    title,
    depth,
    objIndex,
    open,
    label,
    objectType,
    formState,
    setFormState,
    objectListItem,
    ...rest
  } = props;


  const rolesAccessState = useSelector(state => state.rolesAccessState);

  const isTruthy = (value) => value === 1 || value === '1' || value === true;

  useEffect(() => {
    const permissions = rolesAccessState.permissionsListByRole;
    const item = find(permissions, ['object_id', objectListItem.id]);
    if (!isEmpty(item)) {
      setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          role_access_rights: {
            ...formState.values.role_access_rights,
            [item.object_id]: {
              add: isTruthy(item.rights_add),
              edit: isTruthy(item.rights_edit),
              delete: isTruthy(item.rights_delete),
              view: isTruthy(item.rights_view),
              view_deleted: isTruthy(item.rights_view_deleted),
              reporting_access_edit: item.reporting_access_edit || 'disabled',
              reporting_access_delete: item.reporting_access_delete || 'disabled',
              reporting_access_view: item.reporting_access_view || 'disabled',
              object_id: item.object_id,
              office_wise_access: isTruthy(item.office_wise_access),
              client_wise_access: isTruthy(item.client_wise_access),
              client_ids: item.client_ids,
              office_ids: item.office_ids,
              id: item.id,
            },
          },
        },
      }));
    } else {
      setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          role_access_rights: {
            ...formState.values.role_access_rights,
            [objectListItem.id]: {
              add: false,
              edit: false,
              delete: false,
              view: false,
              view_deleted: false,
              reporting_access_edit: 'disabled',
              reporting_access_delete: 'disabled',
              reporting_access_view: 'disabled',
              object_id: objectListItem.id,
              office_wise_access: false,
              client_wise_access: false,
              client_ids: null,
              office_ids: null,
            },
          },
        },
      }));
    }
  }, [rolesAccessState.permissionsListByRole, objectListItem.id, setFormState]);

  if (objectType === 'Page') {
    return (
      <Page
        depth={depth}
        objIndex={objIndex}
        label={label}
        open={open}
        title={title}
        objectType={objectType}
        key={objectListItem.id}
        objectListItem={objectListItem}
        setFormState={setFormState}
        formState={formState}
        {...rest}
      >
      </Page>
    );
  } else if (objectType === 'Component') {
    return (
      <Component
        depth={depth}
        objIndex={objIndex}
        label={label}
        open={open}
        title={title}
        objectType={objectType}
        key={objectListItem.id}
        objectListItem={objectListItem}
        setFormState={setFormState}
        formState={formState}
        {...rest}
      />
    );
  } else {
    return (
      <Module
        depth={depth}
        objIndex={objIndex}
        label={label}
        open={open}
        title={title}
        objectType={objectType}
        key={objectListItem.id}
        objectListItem={objectListItem}
        setFormState={setFormState}
        formState={formState}
        {...rest}
      >
      </Module>
    );
  } 
};

ObjectListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  label: PropTypes.any,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  objectType: PropTypes.string.isRequired
};


export default ObjectListItem;
